export const LIST_BALANCES = 'LIST_BALANCES';
export const LIST_TODAY_SALES = 'LIST_TODAY_SALES'
export const LIST_LAST_SALES = 'LIST_LAST_SALES'
